import { graphql } from 'react-relay';

import { BrandMessageTaskWindowPaginator_query$key } from '../../../relay/__generated__/BrandMessageTaskWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const BrandMessageTaskWindowPaginator_query = graphql`
  fragment BrandMessageTaskWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: BrandMessageTaskFilter }
    order: { type: BrandMessageTaskOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "BrandMessageTaskWindowPaginatorRefreshQuery") {
    brandMessageTasks(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...BrandMessageTaskConnectionDataTable_brandMessageTaskConnection
    }
  }
`;
type Props = {} & Omit<FragmentWindowPaginatorProps<BrandMessageTaskWindowPaginator_query$key>, 'fragment'>;

const BrandMessageTaskWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={BrandMessageTaskWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (paginationProps) => (
          <Pagination {...paginationProps} pages={data.brandMessageTasks.pages} loadPage={loadPage} />
        ),
      })
    }
  </FragmentWindowPaginator>
);

export default BrandMessageTaskWindowPaginator;
